import { MapStyle, StyleTier } from "./types";

// export const STATIC_FILE_URL = "http://localhost:8081";
export const STATIC_FILE_URL = "https://mappin-pro.netlify.app";
export const BACKEND_URL = import.meta.env.VITE_BACKEND || "";

export const GA_ID = "G-6JDZSPEPCP";
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG || "";

// Validate required environment variables
if (!import.meta.env.VITE_BACKEND && import.meta.env.NODE_ENV === 'production') {
  console.warn('VITE_BACKEND environment variable is not set');
}

if (!import.meta.env.VITE_POSTHOG && import.meta.env.NODE_ENV === 'production') {
  console.warn('VITE_POSTHOG environment variable is not set');
}

export const KM_PER_LAT = 110.574;

export const DEFAULT_STYLE = MapStyle.LIGHT;

export const styleInfo: Record<MapStyle, { styleTier: StyleTier; styleId: string; grade: number }> = {
  [MapStyle.NATURAL]: {
    styleId: "ckrtceyfu31hn1bru2erdkunk",
    styleTier: StyleTier.FREE,
    grade: 10,
  },
  [MapStyle.LIGHT]: {
    styleId: "cksd2tl617jrz18qqmfk4iztu",
    styleTier: StyleTier.FREE,
    grade: 10,
  },
  [MapStyle.DARK]: {
    styleId: "cks3zqjwp5txk17qwmxfwkrl9",
    styleTier: StyleTier.FREE,
    grade: 10,
  },
  [MapStyle.GREY]: {
    styleId: "cksd2ygt066f018s3ytkdts9j",
    styleTier: StyleTier.FREE,
    grade: 10,
  },
  [MapStyle.LOVE]: {
    styleId: "ckub3pmlt04wr18mumixvmjoe",
    styleTier: StyleTier.FREE,
    grade: 10,
  },
  [MapStyle.FOREST]: {
    styleId: "ckub40ya37dzh18np16vdujrx",
    styleTier: StyleTier.FREE,
    grade: 10,
  },
  [MapStyle.BLUE]: {
    styleId: "ckwg7ytjs10ce14pf6m12erp4",
    styleTier: StyleTier.PREMIUM,
    grade: 10,
  },
  [MapStyle.TERRAIN]: {
    styleId: "ckwh21fr224dp14mk5e6mm841",
    styleTier: StyleTier.PREMIUM,
    grade: 6,
  },
  [MapStyle.WOOD]: {
    styleId: "ckxstwbp9tgmc16ul3jhysb42",
    styleTier: StyleTier.PREMIUM,
    grade: 5,
  },
  [MapStyle.CARTOON]: {
    styleId: "ckxsu2krad97n15schsm8l1p6",
    styleTier: StyleTier.PREMIUM,
    grade: 5,
  },
  [MapStyle.SATELLITE]: {
    styleId: "ckwh7w4me12pj14rfgznd64zv",
    styleTier: StyleTier.PRO,
    grade: 4,
  },
  [MapStyle.DARK_GREEN]: {
    styleId: "cme5al4wz016c01rh6o232z7b",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.PINK]: {
    styleId: "cme5aeaju016a01rh9jj2h91f",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.YELLOW]: {
    styleId: "cme5ah3l7002401ra49vr4ie1",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.MAGENTA]: {
    styleId: "cme5ab9o3016901rhesfy5ny5",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.DARK_RED]: {
    styleId: "cme5a7ecz00o601re34e1fwg5",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.ORANGE]: {
    styleId: "cm25tzwcs005101pv53w3fdct",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.RED]: {
    styleId: "cmb6m8c8s00jh01sw6c6mcii3",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.TEAL]: {
    styleId: "cme590jr2016601rh7vwt74p1",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.BEIGE]: {
    styleId: "cmd340hbp01fn01sr0cxfc378",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.GREEN]: {
    styleId: "cmd34gig9016901r49ae26f1i",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.PURPLE]: {
    styleId: "cmb6mgnvw00hy01rk4n6uapbm",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.DARK_CYAN]: {
    styleId: "cme59c10q00pf01re1gnsh6uh",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
  [MapStyle.DARK_TURQUOISE]: {
    styleId: "cme58vv1u016501rhgpiudw3j",
    styleTier: StyleTier.STANDARD,
    grade: 10,
  },
};

// Legacy MapIds for backward compatibility
export const MapIds: Record<MapStyle, string> = Object.fromEntries(
  Object.entries(styleInfo).map(([key, value]) => [key, value.styleId])
) as Record<MapStyle, string>;
